import type { CategoryLetterGroup } from "@/types/directory";

export const categoryIndexPartB: CategoryLetterGroup[] = [
  {
    letter: "N",
    categories: [
      { name: "Nail Art Studios", count: 16 },
      { name: "Namkeen Dealers", count: 9 },
      { name: "Natural Gas Dealers", count: 6 },
      { name: "Naturopathy Centres", count: 7 },
      { name: "Nephrologists", count: 8 },
      { name: "Neurologists", count: 11 },
      { name: "Neurosurgeons", count: 6 },
      { name: "Newspaper Agents", count: 19 },
      { name: "NGOs & Voluntary Organizations", count: 53 },
      { name: "Night Clubs", count: 5 },
      { name: "Non-Veg Restaurants", count: 41 },
      { name: "Notary Services", count: 14 },
      { name: "Nursing Homes", count: 21 },
      { name: "Nutritionists", count: 12 },
      { name: "Nut Dealers", count: 7 },
    ],
  },
  {
    letter: "O",
    categories: [
      { name: "Oil Dealers", count: 14 },
      { name: "Oncologists", count: 9 },
      { name: "Opticians & Optical Dealers", count: 48 },
      { name: "Optometrists", count: 13 },
      { name: "Orthopaedic & Bone Specialists", count: 41 },
      { name: "Oxygen Dealers", count: 6 },
    ],
  },
  {
    letter: "P",
    categories: [
      { name: "Packers, Movers & Relocation Services", count: 29 },
      { name: "Paints Dealers", count: 27 },
      { name: "Paper Dealers", count: 13 },
      { name: "Paediatricians & Child Specialists", count: 35 },
      { name: "Pawn Brokers", count: 8 },
      { name: "Perfume Dealers", count: 11 },
      { name: "Pest Control Services", count: 17 },
      { name: "Pet Shops", count: 14 },
      { name: "Petrol Bunks", count: 27 },
      { name: "Pharmaceutical Distributors", count: 16 },
      { name: "Pharmacies & Medical Shops", count: 44 },
      { name: "Photography Studios", count: 35 },
      { name: "Physiotherapists", count: 19 },
      { name: "Pickle Manufacturers", count: 8 },
      { name: "Plastic Dealers", count: 18 },
      { name: "Plumbers & Plumbing Services", count: 60 },
      { name: "Plywood Dealers", count: 14 },
      { name: "Police Stations", count: 19 },
      { name: "Post Offices", count: 31 },
      { name: "Pottery & Clay Products", count: 15 },
      { name: "Printing & Offset Presses", count: 32 },
      { name: "Psychiatrists", count: 12 },
      { name: "Psychologists", count: 14 },
      { name: "PU Colleges", count: 26 },
    ],
  },
  {
    letter: "Q",
    categories: [
      { name: "Quality Certification Services", count: 5 },
      { name: "Quarry Owners", count: 6 },
      { name: "Quartz Dealers", count: 4 },
      { name: "Quilts Dealers", count: 7 },
    ],
  },
  {
    letter: "R",
    categories: [
      { name: "Real Estate Agents & Property Consultants", count: 102 },
      { name: "Research Institutes", count: 6 },
      { name: "Residential Schools", count: 13 },
      { name: "Resorts", count: 21 },
      { name: "Restaurants", count: 92 },
      { name: "Rice Dealers", count: 26 },
      { name: "Roofing Contractors", count: 14 },
      { name: "Rubber Dealers", count: 9 },
      { name: "Rubber Stamps", count: 7 },
    ],
  },
  {
    letter: "S",
    categories: [
      { name: "Sand Dealers", count: 17 },
      { name: "Saree & Silk Saree Dealers", count: 49 },
      { name: "Scaffolding Dealers", count: 8 },
      { name: "Scan & Imaging Centres", count: 34 },
      { name: "Schools", count: 155 },
      { name: "Scrap Dealers", count: 14 },
      { name: "Sea Food Exporters", count: 9 },
      { name: "Security Services", count: 21 },
      { name: "Seed Dealers", count: 13 },
      { name: "Serviced Apartments", count: 12 },
      { name: "Sewing Machine Dealers", count: 10 },
      { name: "Shopping Malls", count: 7 },
      { name: "Shuttering Contractors", count: 9 },
      { name: "Solar Panel Dealers", count: 17 },
      { name: "Sound System Dealers", count: 11 },
      { name: "Spas & Wellness Centres", count: 59 },
      { name: "Spice & Masala Dealers", count: 27 },
      { name: "Sports & Gym Equipment Dealers", count: 29 },
      { name: "Stationery Dealers", count: 26 },
      { name: "Steel & Metal Fabrication", count: 61 },
      { name: "Sweet Stalls", count: 27 },
      { name: "Swimming Pools", count: 8 },
    ],
  },
  {
    letter: "T",
    categories: [
      { name: "Tailors & Ladies Tailors", count: 69 },
      { name: "Tandoori Restaurants", count: 12 },
      { name: "Tattoo Studios", count: 9 },
      { name: "Taxi Services", count: 31 },
      { name: "Tea Dealers", count: 18 },
      { name: "Tea Shops", count: 34 },
      { name: "Teachers Training Institutes", count: 11 },
      { name: "Temples", count: 42 },
      { name: "Tent House", count: 14 },
      { name: "Textile & Fabric Dealers", count: 55 },
      { name: "Theatre Arts", count: 6 },
      { name: "Theme Parks", count: 5 },
      { name: "Ticket Booking Agents", count: 13 },
      { name: "Tiffin Services", count: 19 },
      { name: "Tile Dealers", count: 24 },
      { name: "Timber Dealers", count: 16 },
      { name: "Tinkers", count: 7 },
      { name: "Toy Shops", count: 17 },
      { name: "Travel Agencies & Tour Operators", count: 70 },
      { name: "Transport Contractors", count: 21 },
      { name: "Tyre Dealers", count: 19 },
    ],
  },
  {
    letter: "U",
    categories: [
      { name: "Umbrella Dealers", count: 6 },
      { name: "Uniform Dealers", count: 11 },
      { name: "Upholstery Dealers", count: 13 },
      { name: "Urologists", count: 9 },
      { name: "Used & Second Hand Car Dealers", count: 40 },
    ],
  },
  {
    letter: "V",
    categories: [
      { name: "Vaccination Centres", count: 11 },
      { name: "Vacuum Cleaner Dealers", count: 7 },
      { name: "Valuation Services", count: 9 },
      { name: "Vastu Consultants", count: 12 },
      { name: "Vegetable Dealers", count: 34 },
      { name: "Vending Machine Dealers", count: 6 },
      { name: "Veterinary Clinics & Pet Care", count: 43 },
      { name: "Video Editing Services", count: 11 },
      { name: "Villas", count: 9 },
      { name: "Visas Services", count: 12 },
      { name: "Vocational Training Centres", count: 15 },
    ],
  },
  {
    letter: "W",
    categories: [
      { name: "Wall Putty Dealers", count: 9 },
      { name: "Warehouse Services", count: 13 },
      { name: "Watch Dealers", count: 16 },
      { name: "Watch Repairs", count: 12 },
      { name: "Water Purifier Dealers", count: 39 },
      { name: "Water Supply Services", count: 11 },
      { name: "Water Tank Dealers", count: 14 },
      { name: "Weaving Mills", count: 6 },
      { name: "Weighing Machine Dealers", count: 8 },
      { name: "Wine Shops", count: 12 },
    ],
  },
  {
    letter: "X",
    categories: [
      { name: "Xerox Machine Dealers", count: 8 },
      { name: "Xerox Services", count: 21 },
    ],
  },
  {
    letter: "Y",
    categories: [
      { name: "Yoga Classes & Instructors", count: 41 },
    ],
  },
  {
    letter: "Z",
    categories: [
      { name: "Zoos", count: 2 },
      { name: "Zumba Classes", count: 9 },
    ],
  },
];